import React from 'react'
import { graphql } from 'gatsby'
import PageWrap from '../components/Layouts/PageWrap'
import InsightsHeader from '../components/Headers/InsightsHeader'
import Image from '../components/Images/Image'
import BlockRenderer from '../components/BlockRenderer'

// Header
const transformHeaderData = data => {
  return {
    heading: data.title,
  }
}

// Header Image
const transformImageData = data => {
  return {
    alt: data.node.altText,
    src:
      data.node.mediaDetails.sizes[3] &&
      data.node.mediaDetails.sizes[3].sourceUrl,
  }
}

const Page = ({ data }) => {
  return (
    <PageWrap seo={data?.page?.seo}>
      <div className="mb-20">
        <div className="container max-w-screen-md mb-12">
          <InsightsHeader {...transformHeaderData(data.page)} />
        </div>
        {data.page.featuredImage && (
          <div className="flex my-12 lg:mt-12 lg:mb-20 container max-w-screen-md">
            <Image {...transformImageData(data.page.featuredImage)} />
          </div>
        )}
        <div className="container max-w-screen-md">
          <BlockRenderer blocks={data.page.blocks} />
        </div>
      </div>
    </PageWrap>
  )
}

export default Page

export const query = graphql`
  query($id: String!) {
    page: wpPage(id: { eq: $id }) {
      seo {
        ...seoPostTypeFields
      }
      title
      featuredImage {
        node {
          altText
          mediaDetails {
            sizes {
              sourceUrl
            }
          }
        }
      }
      blocks {
        ...blockFields
      }
    }
  }
`
